var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _c(
        "div",
        { staticClass: "wl-content-container" },
        [
          _c(
            "div",
            { staticClass: "wl-info" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 35 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm._v(_vm._s(_vm.$t("site007"))),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "column-btn",
                        on: { click: _vm.setClick },
                      },
                      [
                        _c("img", {
                          staticClass: "table-setting-icon",
                          attrs: {
                            src: require("@/assets/img/icon-setting.svg"),
                            width: "100%",
                          },
                        }),
                        _c("span", [_vm._v("Adjust The Alert Settings")]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-row", { staticClass: "search-row" }, [
            _c(
              "div",
              { staticClass: "el-col-12 el-row--flex" },
              [
                _c("el-date-picker", {
                  staticClass: "wl-item wl-date-item2 input-with-select margin",
                  attrs: {
                    type: "daterange",
                    "range-separator": "~",
                    "start-placeholder": _vm.$t("begin_date"),
                    "end-placeholder": _vm.$t("end_date"),
                  },
                  model: {
                    value: _vm.value1,
                    callback: function ($$v) {
                      _vm.value1 = $$v
                    },
                    expression: "value1",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { icon: "el-icon-search" },
                    on: { click: _vm.searchBtnClick },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn_search2")) + "\n        ")]
                ),
                _c(
                  "el-button",
                  { staticClass: "cancel-btn", on: { click: _vm.clearAll } },
                  [_vm._v(_vm._s(_vm.$t("COMMON_CLEAR_BTN")) + "\n        ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "el-col-12" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green right",
                    on: { click: _vm.searchBtnClick },
                  },
                  [
                    _c("img", {
                      staticClass: "btn-icon",
                      attrs: {
                        src: require("@/assets/img/icon-export.svg"),
                        width: "100%",
                        alt: "",
                      },
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("BATCH_export")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "table-container-wrapper" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  attrs: {
                    height: "100%",
                    data: _vm.tableData,
                    stripe: "",
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "No.",
                      prop: "no",
                      "header-align": "center",
                      align: "center",
                      width: "60",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Downloaded by",
                      prop: "downloadBy",
                      "header-align": "center",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "th-label" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("table_column_downloaded_by"))
                                ),
                                _c("multi-select-popover"),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "E-mail address",
                      prop: "email",
                      "header-align": "center",
                      align: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "th-label" },
                              [
                                _vm._v(_vm._s(_vm.$t("email_address"))),
                                _c("multi-select-popover"),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "Confirmation",
                        prop: "confirmation",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "PCS",
                          prop: "confirmationPcs",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Size",
                          prop: "confirmationSize",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "Joint Working",
                        prop: "jointWorking",
                        "header-align": "center",
                        align: "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "PCS",
                          prop: "jointWorkingPcs",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Size",
                          prop: "jointWorkingSize",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "PBC",
                        prop: "PBC",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "PCS",
                          prop: "PbcPcs",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Size",
                          prop: "PbcSize",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "Statutory",
                        prop: "statutory",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "PCS",
                          prop: "statutoryPcs",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Size",
                          prop: "statutorySize",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "Total Downloaded Files",
                        prop: "totalDownloadedFiles",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "PCS",
                          prop: "totalDownloadedFilesPcs",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "underline-content waring",
                                    on: { click: _vm.showDownloadFileClick },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          scope.row.totalDownloadedFilesPcs
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Size",
                          prop: "totalDownloadedFilesSize",
                          "header-align": "center",
                          align: "right",
                          sortable: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "underline-content" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.totalDownloadedFilesSize
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Adjust The Alert Settings",
            width: "400px",
            visible: _vm.setVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.setVisible = $event
            },
            close: function ($event) {
              _vm.setVisible = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "setForm",
              attrs: { model: _vm.setForm, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "bottom-line",
                  attrs: {
                    label: "Total Download Files In Past One Weed(pcs)",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 10, label: "描述文字" },
                    model: {
                      value: _vm.setForm.pcs,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "pcs", $$v)
                      },
                      expression: "setForm.pcs",
                    },
                  }),
                  _vm._v(" PCS\n      "),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "bottom-line",
                  attrs: {
                    label: "Total Download Files In Past One Weed(size)",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 10, label: "描述文字" },
                    model: {
                      value: _vm.setForm.pcs,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "pcs", $$v)
                      },
                      expression: "setForm.pcs",
                    },
                  }),
                  _vm._v(" MB\n      "),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      "Alert the engagement manager when the client downloaded files exceeds the risk value set above",
                  },
                },
                [
                  _c("el-switch", {
                    staticClass: "switch-width-cls",
                    attrs: {
                      "active-color": "#409EFF",
                      "inactive-color": "#cccccc",
                    },
                    model: {
                      value: _vm.setForm.switch,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "switch", $$v)
                      },
                      expression: "setForm.switch",
                    },
                  }),
                  _vm._v("\n        Send email alert\n      "),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-gray",
                  attrs: { loading: _vm.dialogLoading },
                  on: { click: _vm.cancelClick },
                },
                [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { loading: _vm.dialogLoading },
                  on: { click: _vm.saveClick },
                },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("download-file-dialog", {
        attrs: { showDownloadVis: _vm.showDownloadVis },
        on: {
          close: function ($event) {
            _vm.showDownloadVis = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }